import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col } from 'antd';
import { CUSTOMER_FIELDS } from '../constants';
import { DEFAULT_SERVER_STATUS } from '../constants';
import TextArea from 'antd/lib/input/TextArea';

export default function CustomerModal({ visible, onCancel, onSave, initialData }) {
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);
  const [rowSpan, setRowSpan] = useState(1);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        form.setFieldsValue(initialData);
        setRowSpan(String(initialData.name).split('\n').length || 1)
      } else {
        form.resetFields();
        setRowSpan(1);
      }
    }
  }, [initialData, form, visible]);

  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values });
    const { success, code } = response;
    setServerResponse({success, code, message: response.message});
    if (success && !response?.message) {
      form.resetFields();
    }
  };

  const onEdit = () => {
    setServerResponse(DEFAULT_SERVER_STATUS);
    const name = form.getFieldValue('name');
    setRowSpan(String(name).split('\n').length || 1)
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={(initialData && initialData.id) ? 'Edit Customer' : 'Add Customer'}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        name="customer"
        layout="vertical"
        onFinish={onFinish}
        >
        <Row gutter={16}>
            {CUSTOMER_FIELDS.map(field => (
              <Col
                key={field.name}
                xs={24}
                sm={24}
                md={['code', 'name'].includes(field.name) ? 24 : 12}
              >
                <Form.Item
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  rules={field.rules}
                >
                  {
                    field.name === 'name' ? (
                      <TextArea rows={rowSpan} onChange={() => {onEdit()}} ></TextArea>
                    ) : (
                      <Input onChange={() => {onEdit()}} />
                    )
                  }
                </Form.Item>
            </Col>
            ))}
        </Row>
        </Form>
        {
          (!serverResponse.status && serverResponse.message) &&
          <div style={{textAlign: 'center'}}>
            <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
          </div>
        }
    </Modal>
  );
}
